import { render } from "./HelpAhsRefugee.vue?vue&type=template&id=2f018a66&scoped=true"
import script from "./HelpAhsRefugee.vue?vue&type=script&lang=js"
export * from "./HelpAhsRefugee.vue?vue&type=script&lang=js"

import "./HelpAhsRefugee.vue?vue&type=style&index=0&id=2f018a66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f018a66"]])

export default __exports__